import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { SUBSCRIPTION_SIGNUP_HREF } from 'pages/certificates/annualpass/data/subscriptionData'
import { SignUpButton } from 'pages/certificates/components/SignUpButton'
import { TrackingAttributes } from 'pages/certificates/tracking'
import { MCCERTS_2972_SUBS_ONLY_CLP_FLAG } from './constants'
import {
  type SubsOnlyClpExpEligibilityProps,
  useSubsOnlyClpExpBucket,
} from './utils/useIsSubsOnlyClpExpActive'

const NAV_BUTTON_CLASS = 'hidden md:inline'

const CertSignUpCta = () => <SignUpButton className={NAV_BUTTON_CLASS} />

const PassSignUpCta = () => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <SignUpButton
      className={NAV_BUTTON_CLASS}
      href={SUBSCRIPTION_SIGNUP_HREF}
      text={t('marketingPages.subscription.hero.cta')}
      // purchaseClick action pinned to its historical value (see SubscriptionSignUpCTA)
      action='Get All Courses'
    />
  )
}

export const CMNavSignUpCtaSubsOnlyExp = (
  props: SubsOnlyClpExpEligibilityProps,
) => {
  const bucket = useSubsOnlyClpExpBucket(props)
  if (!bucket) {
    return <CertSignUpCta />
  }

  return (
    <TrackingAttributes variant={bucket}>
      {/* track={false}: the page-level TrackExperimentViewed owns the exposure */}
      <Experiment
        name={MCCERTS_2972_SUBS_ONLY_CLP_FLAG}
        track={false}
        default={CertSignUpCta}
        variant_1={PassSignUpCta}
        variant_2={PassSignUpCta}
        variant_3={PassSignUpCta}
      />
    </TrackingAttributes>
  )
}
